import React, { useEffect, useMemo } from 'react';
import { HelpCircle } from 'lucide-react';
import logo from '../../HowIMetYourMortgageLogo2.png';
import { useAuth } from '../../hooks/useAuth';
import { SignInButton } from '../Auth/SignInButton';
import { UserMenu } from '../Auth/UserMenu';
import { CalculatorParams, AnalysisResponse } from '../../types/api';

interface HeaderProps {
  className?: string;
  currentParameters?: CalculatorParams;
  currentAnalysisResult?: AnalysisResponse;
  onLoadAnalysis?: (parameters: CalculatorParams) => void;
  onOpenTutorial?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ 
  className = '', 
  currentParameters, 
  currentAnalysisResult, 
  onLoadAnalysis,
  onOpenTutorial
}) => {
  // Save-related UI moved into App panel above slider
  const { user } = useAuth();

  // Expose scenario titles globally so SaveAnalysisModal can include them
  useEffect(() => {
    try {
      const titles = (window as any).__SCENARIOS__?.map((s: any) => s.title) || [];
      (window as any).__SCENARIO_TITLES__ = titles;
    } catch {}
  }, []);

  return (
    <>
      <header className={`flex items-center justify-between p-6 bg-white border-b border-gray-200 ${className}`}>
        <div className="flex items-center">
          <img src={logo} alt="How I Met Your Mortgage" className="h-14 w-auto transform scale-150 origin-left" />
        </div>

        <div className="flex items-center space-x-4">
          {/* How to Use button */}
          <button
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-100 hover:bg-blue-200 text-blue-700 transition-colors duration-200"
            onClick={() => {
              if (onOpenTutorial) {
                onOpenTutorial();
              }
            }}
            title="How It Works"
          >
            <HelpCircle className="w-5 h-5" />
            <span className="text-sm font-medium">How It Works</span>
          </button>

          {/* Save controls moved into main panel */}

          {/* Authentication */}
          {user ? (
            <UserMenu />
          ) : (
            <SignInButton />
          )}
        </div>
      </header>
      
      {/* Save-related modals moved into App */}
    </>
  );
};
